import { LoaderListItem } from '../../ListItem'

import * as styles from './SelectDropdownAsyncListInitialLoader.module.css'

function SelectDropdownAsyncListInitialLoader({
  className = styles.SelectDropdownAsyncListInitialLoader,
  hasText = true,
  ...restProps
}) {
  return (
    <div {...restProps} className={className}>
      <LoaderListItem hasText={hasText} />
    </div>
  )
}

export default SelectDropdownAsyncListInitialLoader
